declare namespace $ {

	export class $bog_builderui_skin extends $mol_plugin {
		lights( ): string
		base( ): string
		accent( ): string
		chart( ): string
		radius( ): string
		font_body( ): string
		font_head( ): string
		attr( ): ({ 
			'bog_builderui_lights': ReturnType< $bog_builderui_skin['lights'] >,
			'bog_builderui_base': ReturnType< $bog_builderui_skin['base'] >,
			'bog_builderui_theme': ReturnType< $bog_builderui_skin['accent'] >,
			'bog_builderui_chart': ReturnType< $bog_builderui_skin['chart'] >,
			'bog_builderui_radius': ReturnType< $bog_builderui_skin['radius'] >,
			'bog_builderui_font_body': ReturnType< $bog_builderui_skin['font_body'] >,
			'bog_builderui_font_head': ReturnType< $bog_builderui_skin['font_head'] >,
		}) 
	}
	
}

//# sourceMappingURL=skin.view.tree.d.ts.map